var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-spinner"},[_c('div',[_c('b-spinner',{staticClass:"m-r-8"}),_c('span',[_vm._v(_vm._s(_vm.localText))])],1),(_vm.hint)?_c('div',{staticClass:"ui-spinner_hint"},[_vm._v(_vm._s(_vm.localHint))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }